var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNurseOnboarding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279 279",
    style: {
      enableBackground: "new 0 0 279 279"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#436168;stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.2,107.6C61.2,70,106.5,40,140,72.3c0,0-17.7-40.8-58.1-38.2C60.4,35.5,41,48.2,31.1,67.4 c-6.4,12.4-10.1,29.2-3.3,50.4c2.5,7.6,6.1,14.8,10.7,21.4c1.8,2.5,3.6,5,5.7,7.3c8.9,10.3,25.8,27,42.8,41.2 c0,0,42.1,34.5,52.2,57.3c0-29.1-12.5-58.8-31.4-80.6C93.4,147.8,70.9,131.6,67.2,107.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.9,124.7h22.8l9.9,25.2l7-25.2l7-25.2l9.9,25.2h7.5h7.5l9.9,25.2l7-25.2l7-25.2l9.9,25.2c0.1,0,0.2,0,0.3,0 c22.2,0,39.3-20.6,34.3-42.2c-1.1-4.7-2.8-9.4-5.1-14c-9.7-19.3-28.9-32.1-50.4-33.7C158.1,31.7,140,72.3,140,72.3 s-17.7-40.8-58.1-38.2C60.4,35.5,41,48.2,31.1,67.4c-6.4,12.4-10.1,29.2-3.3,50.4c2.5,7.6,6.1,14.8,10.7,21.4c1.8,2.5,3.6,5,5.6,7.3 c8.9,10.3,25.8,27,42.8,41.2c0,0,42.1,34.5,52.2,57.3c10.3-22.7,52.8-56.8,52.8-56.8c12.8-10.5,24.8-21.6,34.2-31.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurseOnboarding);
export default __webpack_public_path__ + "static/media/Nurse_onboarding.e5a9c14669dfe7bf8d00b7936111a24c.svg";
export { ForwardRef as ReactComponent };